import React, { Key, memo, useCallback } from 'react';
import { styled } from '@material-ui/core';
import { colors } from '../../../infrastructure/newDesignTheme';
import Checkbox from '@material-ui/core/Checkbox';

import {
  Columns,
  NkDropdown,
  NkSearchInput,
  NkSimpleButton,
  theme,
} from '../../../index';
import { ControlPanelActions } from '../nkCustomTable.types';
import IconArrow from '../../icons/iconArrow';

interface NkControlPanelProps {
  isOnDeleteDisabled: boolean;
  selectedRows: Array<Key>;
  columns: Columns;
  controlPanelActions: ControlPanelActions;
}

const NkControlPanel = ({
  isOnDeleteDisabled,
  selectedRows,
  columns,
  controlPanelActions: { onAdd, onDelete, onSearch, onVisibleColumns },
}: NkControlPanelProps) => {
  const handleOnDelete = () => {
    onDelete?.(selectedRows);
  };
  const handleChange = useCallback(
    ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      onVisibleColumns?.({
        name: target.name,
        isHide: !target.checked,
      });
    },
    [onVisibleColumns],
  );

  return (
    <StyledPanel>
      <StyledControlBlock>
        {onSearch ? <NkSearchInput onSearch={onSearch} /> : null}
        {onVisibleColumns ? (
          <NkDropdown
            position="bottom"
            menuIndent={theme.spacing(2)}
            menu={columns.map((column) => {
              return (
                <StyledLabel>
                  <span>{column.title}</span>
                  <Checkbox
                    color="default"
                    key={column.key}
                    name={column.key}
                    checked={!column.isHide}
                    onChange={handleChange}
                  />
                </StyledLabel>
              );
            })}
          >
            <StyledButton
              label="visible columns"
              name="dropdown"
              endIcon={<IconArrow color={theme.palette.text.primary} />}
            />
          </NkDropdown>
        ) : null}
      </StyledControlBlock>
      <StyledControlBlock>
        {onDelete ? (
          <StyledButton
            label="delete"
            name="delete"
            onClick={handleOnDelete}
            isDisabled={isOnDeleteDisabled}
          />
        ) : null}
        {onAdd ? <StyledButton label="add" name="add" onClick={onAdd} /> : null}
      </StyledControlBlock>
    </StyledPanel>
  );
};

export default memo(NkControlPanel);

const StyledPanel = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  // TODO: change this to appropriate theme color once theming is done on app level
  backgroundColor: colors.almostHuman,
  padding: theme.spacing(2),
}));

const StyledButton = styled(NkSimpleButton)(({ theme }) => ({
  borderRadius: '50px',
  textTransform: 'lowercase',
  backgroundColor: theme.customProps.backgroundColor,
  fontWeight: 'bold',
  padding: `4px ${theme.spacing(2)}px`,
  fontSize: '16px'
}));

const StyledControlBlock = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: theme.spacing(2),
}));

const StyledLabel = styled('label')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: theme.spacing(1),
  whiteSpace: 'nowrap',
  cursor: 'pointer',
}));
